import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  allContracts: [{}],
  customerContract: null,
  createContract: {},
  contract: {},
  updateContract: {},
  customerContracts: [{}],
  deletedContract: {},
  customerAssets: [{}],
  contractAssets: [{}],
  componentAssets: [{}],
  exportCVSContract: {},
  importCVSContract: {},
  newAssetToContract: {},
  allContractsWithSiteIDS: [{}],
  allAssetsWithSiteIDS: [{}],
  updateAsset: {},
  deleteAsset: {},
  warrantyInfo: [{}],
  warrantyInfoWithSiteIDS: [{}],
  notificationUsers: {},
  newNotificationUser: {},
  customerNotificationUser: [{}],
  notificationStatus: {},
  deletedNotificationUser: {},
  isLoading: false,
  error: null,
};

const assetSlice = createSlice({
  name: 'asset',
  initialState,
  reducers: {
    start: (state) => {
      state.error = null;
      state.isLoading = true;
    },
    setReducerError: (state, action) => {
      state.error = action.payload;
    },
    setAllContracts: (state, action) => {
      state.allContracts = action.payload;
      state.error = null;
    },
    setCreateContract: (state, action) => {
      state.createContract = action.payload;
      state.error = null;
    },
    setContract: (state, action) => {
      state.contract = action.payload;
      state.error = null;
    },
    setUpdateContract: (state, action) => {
      state.updateContract = action.payload;
      state.error = null;
    },
    setCustomerContracts: (state, action) => {
      state.customerContracts = action.payload;
      state.error = null;
    },
    setCustomerContract: (state, action) => {
      state.customerContract = action.payload;
      state.error = null;
    },
    setAllContractsWithSiteIDS: (state, action) => {
      state.allContractsWithSiteIDS = action.payload;
      state.error = null;
    },
    setDeletedContract: (state, action) => {
      state.deletedContract = action.payload;
      state.error = null;
    },
    setCustomerAssets: (state, action) => {
      state.customerAssets = action.payload;
      state.error = null;
    },
    setContractAssets: (state, action) => {
      state.contractAssets = action.payload;
      state.error = null;
    },
    setAllAssetsWithSiteIDS: (state, action) => {
      state.allAssetsWithSiteIDS = action.payload;
      state.error = null;
    },
    setComponentAssets: (state, action) => {
      state.componentAssets = action.payload;
      state.error = null;
    },
    setExportCVSContract: (state, action) => {
      state.exportCVSContract = action.payload;
      state.error = null;
    },
    setImportCVSContract: (state, action) => {
      state.importCVSContract = action.payload;
      state.error = null;
    },
    setNewAssetToContract: (state, action) => {
      state.newAssetToContract = action.payload;
      state.error = null;
    },
    setUpdateAsset: (state, action) => {
      state.updateAsset = action.payload;
      state.error = null;
    },
    setDeleteAsset: (state, action) => {
      state.deleteAsset = action.payload;
      state.error = null;
    },
    setWarrantyInfo: (state, action) => {
      state.warrantyInfo = action.payload;
      state.error = null;
    },
    setWarrantyInfoWithSiteIDS: (state, action) => {
      state.warrantyInfoWithSiteIDS = action.payload;
      state.error = null;
    },
    setNotificationUsers: (state, action) => {
      state.notificationUsers = action.payload;
      state.error = null;
    },
    setNewNotificationUser: (state, action) => {
      state.newNotificationUser = action.payload;
      state.error = null;
    },
    setDeletedNotificationUser: (state, action) => {
      state.deletedNotificationUser = action.payload;
      state.error = null;
    },
    setCustomerNotificationUser: (state, action) => {
      state.customerNotificationUser = action.payload;
      state.error = null;
    },
    setNotificationStatus: (state, action) => {
      state.notificationStatus = action.payload;
      state.error = null;
    },
    setResetAsset: () => {
      return initialState;
    },
  },
});

export const {
  start,
  setReducerError,
  setAllContracts,
  setCreateContract,
  setContract,
  setUpdateContract,
  setCustomerContracts,
  setCustomerContract,
  setAllContractsWithSiteIDS,
  setDeletedContract,
  setCustomerAssets,
  setContractAssets,
  setComponentAssets,
  setExportCVSContract,
  setImportCVSContract,
  setNewAssetToContract,
  setAllAssetsWithSiteIDS,
  setUpdateAsset,
  setDeleteAsset,
  setWarrantyInfo,
  setWarrantyInfoWithSiteIDS,
  setNotificationUsers,
  setNewNotificationUser,
  setCustomerNotificationUser,
  setNotificationStatus,
  setDeletedNotificationUser,
  setResetAsset,
} = assetSlice.actions;

export default assetSlice.reducer;
